<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="基本信息" name="1">
        <div class="form-detail-container">
          <el-row :gutter="20" v-if="isManager==false" >
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">经营者名称：</span>
                <span class="detail-desc">{{formData.realManagerName}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">门店：</span>
                <span class="detail-desc">{{formData.storeName}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">房源编码：</span>
                <span class="detail-desc">{{formData.roomCode}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">房源名称：</span>
                <span class="detail-desc">{{formData.roomName}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">房间号：</span>
                <span class="detail-desc">{{formData.roomNumber}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">房型：</span>
                <span class="detail-desc">{{formData.roomTypeName}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">出租类型：</span>
                <span class="detail-desc">{{formData.rentTypeName}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">经营面积(㎡)：</span>
                <span class="detail-desc">{{formData.roomSize}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">房屋间数：</span>
                <span class="detail-desc">{{formData.bedroomNum}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">床位数：</span>
                <span class="detail-desc">{{formData.bedNum}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="detail-item">
                <span class="detail-label">宜住人数：</span>
                <span class="detail-desc">{{formData.maxLiveNum}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="detail-item">
                <span class="detail-label">归属省市区：</span>
                <span class="detail-desc">{{`${formData.province}${formData.city}${formData.region}`}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="detail-item">
                <span class="detail-label">房源地址：</span>
                <span class="detail-desc">{{formData.addrDetail}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="detail-item">
                <span class="detail-label">房源定位：</span>
                <div class="detail-desc" v-show="formData.xpoint != '--' && formData.xpoint != '--'" id="locate-map-detail"></div>
                <span class="detail-desc" v-show="formData.ypoint == '--' || formData.ypoint == '--'">(无法定位)</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">街道：</span>
                <span class="detail-desc">{{formData.streetOffice}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">社区：</span>
                <span class="detail-desc">{{formData.neighborCmm}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">派出所：</span>
                <span class="detail-desc">{{formData.policeStationName}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">房屋编码：</span>
                <span class="detail-desc">{{formData.addrCode}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="detail-item">
                <span class="detail-label">简要情况：</span>
                <span class="detail-desc">{{formData.briefInfo}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="detail-item">
                <span class="detail-label">照片：</span>
                <div class="detail-desc detail-img">
                  <template v-for="(itemUrl,index) in formData.photoUrl" :key="'ii6i_w'+index">
                    <el-image
                      style="width: 100px; height: 100px"
                      fit="cover"
                      :src="itemUrl"
                      :preview-src-list="[itemUrl]"
                      :z-index="99999"
                    >
                    </el-image>
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
      <el-collapse-item title="产权信息" name="2">
        <div class="form-detail-container">
          <div v-show="!formData.ownerCompany || formData.ownerCompany=='--'">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">产权人：</span>
                  <span class="detail-desc">{{formData.ownerName}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">联系电话：</span>
                  <span class="detail-desc">{{formData.ownerPhone}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">国籍：</span>
                  <span class="detail-desc">{{formData.ownerCountryName}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">外文姓：</span>
                  <span class="detail-desc">{{formData.ownerLastName}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">外文名：</span>
                  <span class="detail-desc">{{formData.ownerFirstName}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">证件种类：</span>
                  <span class="detail-desc">{{formData.ownerCertTypeName}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">证件号码：</span>
                  <span class="detail-desc">{{formData.ownerCertCode}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">不动产权证书编号：</span>
                  <span class="detail-desc">{{formData.realStateCode}}</span>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-show="formData.ownerCompany && formData.ownerCompany!='--'">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">产权单位：</span>
                  <span class="detail-desc">{{formData.ownerCompany}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">联系电话：</span>
                  <span class="detail-desc">{{formData.ownerPhone}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">社会信用代码：</span>
                  <span class="detail-desc">{{formData.ownerCreditCode}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="detail-item">
                  <span class="detail-label">不动产权证书编号：</span>
                  <span class="detail-desc">{{formData.realStateCode}}</span>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="detail-item">
                <span class="detail-label">附件：</span>
                <div class="detail-box" style="flex-wrap: wrap;text-align: center ">
                  <template v-for="(itemUrl,index) in formData.attachIdUrl" :key="'iii_'+index">
                    <el-image
                      style="width: 100px; height: 100px"
                      fit="cover"
                      :src="itemUrl"
                      :preview-src-list="[itemUrl]"
                      :z-index="99999"
                    ></el-image>
                  </template>
                  {{(!formData.attachIdUrl||formData.attachIdUrl.length==0)?'--':''}}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
      <el-collapse-item title="设备信息" name="4">
        <div class="form-detail-container">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">智能门锁：</span>
                <span class="detail-desc">{{formData.lockDeviceCode ? formData.lockDeviceCode:'--'}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">型号：</span>
                <span class="detail-desc">{{formData.lockDeviceModel ? formData.lockDeviceModel:'--'}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">智能门铃：</span>
                <span class="detail-desc">{{formData.bellDeviceCode ? formData.bellDeviceCode:'--'}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">型号：</span>
                <span class="detail-desc">{{formData.bellDeviceModel ? formData.bellDeviceModel:'--'}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
      <el-collapse-item title="审核信息" name="5">
        <div class="form-detail-container" v-for="(item, index) of formData.approveRecordDTOList" :key="index">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">审核状态：</span>
                <span class="detail-desc">{{getReviewStatus(item.approveResult)}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">操作时间：</span>
                <span class="detail-desc">{{item.approveTime ? formatTime(item.approveTime):'--'}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">操作人：</span>
                <span class="detail-desc">{{item.approveName ? item.approveName:'--'}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">说明：</span>
                <span class="detail-desc">{{item.approveOpinion ? item.approveOpinion:'--'}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import locationDefaultIcon from '@/assets/img/dashboard/statistics/location-icon-default.png'
import {formatTime} from "@/utils/index.js";

export default {
  name: 'employeeDetail',
  mixins: [tableMix],
  components: { RTable },
  data() {
    let detailKeys = ['realManagerName','storeName','roomCode','roomName','roomNumber','roomTypeName',
      'rentTypeName','roomSize','bedroomNum','bedNum','maxLiveNum','province','city','region',
      'addrDetail','xpoint','ypoint','streetOffice','neighborCmm','policeStationName','addrCode',
      'briefInfo','photoUrl','ownerName','ownerPhone','ownerCountryName','ownerLastName','ownerFirstName',
      'ownerCertTypeName','ownerCertCode','realStateCode','ownerCompany','ownerPhone','ownerCreditCode','realStateCode',
      'attachIdUrl','lockDeviceCode','lockDeviceModel','bellDeviceCode','bellDeviceModel','reviewerName','reviewInfo',
      'reviewStatus','reviewTime','approveRecordDTOList'
    ]  
    let formData = {}
    detailKeys.map((key)=>{
      formData[key] = ''
    })
    return {
      locationDefaultIcon,
      activeNames:['0', '1','2','3','4','5','6'],
      item:{value:'aaa'},
      detailKeys:detailKeys,
      formData:formData,
      noCheckFunc:true,
      userInfo: {},
    }
  },
  props: {
    selOptions: {
      type: Object,
      default:{roomType:[],classifyValue:[],rentType:[],wyfptdwbm:[],ownerCountry:[],ownerCertType:[],jyzbm:[]},
    },
    detailModal: { type: Boolean, default: false },
    detailData: { type: Object, default: {} },
  },
  computed: {
    // 是否为房东（ 4经营者、 5管家）
    isManager() {
      if (this.userInfo.userType == 5 || this.userInfo.userType == 4) return true
      return false
    }
  },
  watch:{
    detailModal:{
      immediate: true,
      handler: function(to){
        if(to===false){
          return false
        }

        this.detailKeys.forEach((key)=>{
          this.formData[key] = this.detailData[key] ? this.detailData[key]:'--'
        })
        this.showManager = ''

        //勿删除
        //this.getHasCheckFunc(this.detailData.dwbgdzSfbm,this.detailData.dwbgdzSbm,this.detailData.dwbgdzQbm)

        if (this.formData.xpoint != '--' && this.formData.ypoint != '--') {
          this.$nextTick(() => {
            setTimeout(() => {
              this.reLocateMap()
            }, 200);
          })
        }
      }
    }
  },
  created(){
    let userInfo = localStorage.getItem('user')
    this.userInfo = userInfo ? JSON.parse(userInfo) : {}
  },
  mounted() {
    this.initLocateMap()
  },
  methods: {
    formatTime,
    getReviewStatus(status){
      return {
        1: "审核中",
        2: "已通过",
        3: "未通过",
        4: "已注销",
      }[status] || '--';
    },
    // 初始化地图
    initLocateMap(lng = 113.946069, lat = 22.550606) {
      let point = { lng, lat }
      let defaultIcon = new BMap.Icon(this.locationDefaultIcon, new BMap.Size(21.3, 25))
      defaultIcon.setImageSize(new BMap.Size(21.3, 25))

      let map = new BMap.Map('locate-map-detail', { enableMapClick: false })
      let poi = new BMap.Point(point.lng, point.lat)
      let marker = new BMap.Marker(poi, { icon: defaultIcon }) // 覆盖物
      map.centerAndZoom(poi, 17)
      map.enableScrollWheelZoom(true)

      this.locateMap = map
      this.locateMap.addOverlay(marker)
    },
    // 重定位地图
    reLocateMap() {
      if (this.locateMap) {
        this.locateMap.clearOverlays()
        let defaultIcon = new BMap.Icon(this.locationDefaultIcon, new BMap.Size(21.3, 25))
        defaultIcon.setImageSize(new BMap.Size(21.3, 25))

        this.$nextTick(() => {
          let poi = new BMap.Point(this.formData.xpoint, this.formData.ypoint)
          let marker = new BMap.Marker(poi, { icon: defaultIcon })
          this.locateMap.centerAndZoom(poi, 17)
          this.locateMap.addOverlay(marker)
        })
      } else {
        this.initLocateMap(this.detailData.xpoint, this.detailData.ypoint)
      }
    },
    // 获取用户是否拥有审核流程
    getHasCheckFunc(province, city, region) {
      let url = 'SAAS.AUDIT_CONFIG_QUERY_ONE'

      let params = {
        params: JSON.stringify({ province, city, region }),
        start: 0,
        size: 1,
        toExcel: false,
      }

      this.noCheckFunc = false
      this.fetchData({ url, method: 'get', params })
        .then((res) => {
          if (res && res.data) {
            let temp = res.data || {}
            if (temp.id) {
              this.noCheckFunc = temp.houseStatus == 2
            }
          }
        })
    },
  }
}
</script>

<style lang="less" scoped>
.form-detail-container {
  padding: 15px 20px;
  background-color: #f5f5f5;
  border-radius: 3px;
}

.detail-item {
  display: flex;
  margin-bottom: 4px;
  .detail-label {
    color: #959697;
  }
  .detail-desc {
    flex: 1;
    text-align: justify;
  }
  .detail-img {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.el-image{
  margin-right: 15px;
}
.el-collapse{
  width: 100%;
}
#locate-map-detail {
  width: 100%;
  height: 200px;
}
</style>
